import { render, staticRenderFns } from "./ticketCode.vue?vue&type=template&id=6bd990c2&scoped=true"
import script from "./ticketCode.vue?vue&type=script&lang=js"
export * from "./ticketCode.vue?vue&type=script&lang=js"
import style0 from "./ticketCode.vue?vue&type=style&index=0&id=6bd990c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd990c2",
  null
  
)

export default component.exports